// src/components/DirectMessageModal.jsx
import React, { useState, useEffect, useRef, useContext } from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';
import { MessageList }                   from 'react-chat-elements';
import { UserContext }                   from '../../userAlertContext';
import axios                             from '../axiosAlertConfig';
import 'react-chat-elements/dist/main.css';

const mapRow = (m, meID) => ({
  position : m.senderUserID === meID ? 'right' : 'left',
  type     : 'text',
  text     : m.messageText || '',
  date     : new Date(m.createdAt),
  title    : m.senderName,
});

export default function DirectMessageModal({ show, onHide, peer }) {
  const { user } = useContext(UserContext);           // me
  const [rows, setRows]   = useState([]);
  const [text, setText]   = useState('');
  const [busy, setBusy]   = useState(false);
  const scrollRef         = useRef(null);

  /* load on open + poll every 10 s */
  useEffect(() => {
    if (!show) return;
    const load = async () => {
      const { data } = await axios.get(
        `/ialert/dm/${user.userID}/${peer.userID}`
      );
      if (data?.success) setRows(data.messages);
    };
    load();
    const id = setInterval(load, 10_000);
    return () => clearInterval(id);
  }, [show, peer.userID, user.userID]);

  /* auto-scroll */
  useEffect(() => {
    if (scrollRef.current)
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [rows]);

  /* send */
  const handleSend = async () => {
    if (busy || !text.trim()) return;
    setBusy(true);
    try {
      const { data } = await axios.post('/ialert/dm', {
        iAccountID       : user.iAccountID,
        senderUserID     : user.userID,
        recipientUserID  : peer.userID,
        senderName       : `${user.firstName} ${user.lastName}`.trim(),
        senderMobileNumber: user.userMobileNumber,
        messageText      : text.trim(),
      });
      if (data?.success && data.message)
        setRows(prev => [...prev, data.message]);
      setText('');
    } finally { setBusy(false); }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>DM with {peer.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{height:'60vh', display:'flex', flexDirection:'column'}}>
        <div ref={scrollRef} style={{flex:1, overflowY:'auto', padding:8}}>
          <MessageList dataSource={rows.map(r => mapRow(r, user.userID))}/>
        </div>
        <Form
          className="border-top d-flex gap-2 p-2"
          onSubmit={e => { e.preventDefault(); handleSend(); }}>
          <Form.Control
            size="sm"
            value={text}
            onChange={e => setText(e.target.value)}
            placeholder="Message…"
          />
          <Button size="sm" type="submit" disabled={busy}>
            {busy ? <Spinner size="sm" animation="border"/> : 'Send'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
